import type { OrgChatSelectedConnector } from '@/components/org-chat/org-chat-types';
import { toConnectorSelection } from './composer-connector-options';

type ConnectorQueueFields = {
  selectedConnectors?: Array<OrgChatSelectedConnector>;
};

/** Keep the composer's canonical connector selection in queued message data. */
export function getConnectorQueueFields(
  selectedConnectors: Array<OrgChatSelectedConnector> | undefined
): ConnectorQueueFields {
  return selectedConnectors === undefined
    ? {}
    : { selectedConnectors: selectedConnectors.map(toConnectorSelection) };
}
